import script from "./VeriftySocial.vue?vue&type=script&setup=true&lang=js"
export * from "./VeriftySocial.vue?vue&type=script&setup=true&lang=js"

import "./VeriftySocial.vue?vue&type=style&index=0&id=239ca78c&lang=scss"

const __exports__ = script;

export default __exports__